export default "__VITE_ASSET__CjL2mBhm__"